<template>
    <div>
        <card-header title="Edit Payment Plan Item" icon="fa-pencil"/>

        <card-body>
            <plan-item-form :item="item"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteItem"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Item?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button type="is-primary" size="is-small" @click="submit" :disabled="!item.type || !item.due_on || !item.title"><i class="fas fa-check mr-2"></i>Save Item</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "../../TIER/components/CardHeader";
    import CardBody from "../../TIER/components/CardBody";
    import CardFooter from "../../TIER/components/CardFooter";
    import CardList from "../../TIER/components/CardList";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import ContainerListItem from "../../TIER/components/ContainerListItem";
    import {client as http} from "../../http_client";
    import TripNoteForm from "@/cards/trips/NoteForm";
    import PlanItemForm from "./PlanItemForm";

    export default {
        components: {PlanItemForm, TripNoteForm, ContainerListItem, SubheaderListItem, CardList, CardFooter, CardBody, CardHeader},
        props: ['card', 'props'],
        data: function () {
            return {
                item: {},
                confirmDelete: false,
                dirty: null
            };
        },
        methods: {
            loadItem: function () {
                this.$emit('loading', true);
                http.get('/api/payment_plans/' + this.props.planId + '/item/' + this.props.itemId, {force: true}).then(response => {
                    this.item = response.data;
                    this.$emit('loading', false);
                });
            },
            submit() {
                this.$emit('loading', true);
                http.put('/api/payment_plans/' + this.props.planId + '/item/' + this.props.itemId, this.item, {force: true}).then(response => {
                    this.$reloadCard('payment-plan', {planId: this.props.planId});
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            },
            deleteItem() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);

                    http.delete('/api/payment_plans/' + this.props.planId + '/item/' + this.props.itemId).then(response => {
                        this.$reloadCard('payment-plan', {planId: this.props.planId});
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            }
        },
        watch: {
            'props.itemId': function () {
                this.dirty = null;
                this.loadItem();
            },
            'item': {
                deep: true,
                handler: function () {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this item? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadItem();
        }
    };
</script>

<style scoped>

</style>
